exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map-area {\n  position: relative;\n}\n\n#car_img {\n  display: none;\n}\n\n#effect_canvas {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\topacity: 0.7;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/car-map/car-map.component.css
// module id = ../../../../../src/app/utilities/car-map/car-map.component.css
// module chunks = main